import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheStorageService {

  constructor() { }

  static async getCache(key: string, url: string) {
    try {
      const cacheStorage = await caches.open(key);
      const cachedResponse = await cacheStorage.match(url);

      if (!cachedResponse || !cachedResponse.ok) return false;
      if (cachedResponse === undefined) return false;

      const blob = await cachedResponse.blob();
      return URL.createObjectURL(blob);
    } catch (err) {
      console.log(err);
    }

    return false;
  }

  static async match(key: string, url: string) {
    try {
      const cacheStorage = await caches.open(key);
      const cachedResponse = await cacheStorage.match(url);

      if (!cachedResponse || !cachedResponse.ok) return false;
      if (cachedResponse === undefined) return false;

      return true;
    } catch (err) {
      console.log(err);
    }

    return false;
  }

  static async getKeys(key: string) {
    const cacheStorage = await caches.open(key);
    return await cacheStorage.keys();
  }

  static async setCache(key: string, url: string) {
    const cacheStorage = await caches.open(key);
    await cacheStorage.add(url);

  }

  static async deleteCache(key: string, url: string) {
    const cacheStorage = await caches.open(key);
    await cacheStorage.delete(url);
  }

  static async deleteAll(key: string) {
    await caches.delete(key);
  }
}
